import { Link } from "react-router-dom";
import { site, testimonials } from "@/mocks/content";

export default function BrandSection() {
  return (
    <section id="about" aria-labelledby="brand-title" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-accent-700">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-water-flash-line text-base" aria-hidden="true" />
              </span>
              ABOUT CHIGUA
            </span>
            <h2 id="brand-title" className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              我们只做一件事：把瓜理清楚
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              {site.name}成立于 {site.since} 年，专注网红圈的公开事件整理。我们不追热点标题，
              更在意一件事的来龙去脉：谁先说了什么、证据出现在哪一天、当事方如何回应。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              所有内容只整理公开可查的信息，对尚未确认的部分明确标注。我们相信，
              让读者看清时间线，比替读者下结论更有价值。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {site.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-200/80 bg-background-100/60 p-3.5"
                >
                  <p className="font-heading text-lg font-bold text-primary-600">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-foreground-800"
              >
                了解我们
              </Link>
              <Link
                to="/about#tips"
                className="whitespace-nowrap rounded-md border border-background-300/80 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors duration-200 hover:border-primary-400 hover:text-primary-600"
              >
                爆料投稿
              </Link>
            </div>
          </div>

          <div id="voice" className="lg:pt-8">
            <h3 className="font-heading text-base font-bold text-foreground-950">围观群众怎么说</h3>
            <div className="mt-4 flex flex-col gap-3">
              {testimonials.map((item) => (
                <blockquote
                  key={item.name}
                  className="rounded-lg border border-background-200/80 bg-background-100/50 p-4"
                >
                  <p className="text-sm leading-relaxed text-foreground-700">“{item.text}”</p>
                  <footer className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-200 font-heading text-[11px] font-bold text-secondary-900">
                      {item.name.slice(0, 1)}
                    </span>
                    <span className="font-medium text-foreground-800">{item.name}</span>
                    <span>· {item.role}</span>
                  </footer>
                </blockquote>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}